"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lifecycles = exports.TranslationsViewPure = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var TranslationsActions = require("@caddigital/sok-reducers/lib/actions/translations");
var Types = require("types");
var FileUpload_1 = require("./FileUpload");
require("./style.scss");
var mapStateToProps = function (_a) {
    var translations = _a.translations;
    return {
        excelInfo: translations.excelInfo,
        value: translations.translationsFile.file,
        file: translations.translationsFile
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    onChange: function (files) {
        dispatch(TranslationsActions.setTranslationsFile([files[files.length - 1]]));
    },
    loadTranslations: function () {
        dispatch(TranslationsActions.fetchExcelInfoRequest());
    },
    uploadFile: function (files) {
        if (files[0]) {
            dispatch(TranslationsActions.uploadTranslationsFile([files[files.length - 1]]));
        }
    },
    clear: function () { return dispatch(TranslationsActions.clearSystem()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
//#endregion
var TranslationsViewPure = function (props) { return (React.createElement("div", { className: 'content-wrapper-content' },
    React.createElement("div", { className: "translations-view" },
        React.createElement("main", { className: 'content' },
            React.createElement(sok_ui_1.BreadCrumb, null,
                React.createElement(react_router_dom_1.Link, { to: "/" }, "SokoPro"),
                React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/sokoprotranslate'))),
            React.createElement(FileUpload_1.FileUpload, __assign({}, props)))))); };
exports.TranslationsViewPure = TranslationsViewPure;
//#region Life Cycles
exports.lifecycles = (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.loadTranslations();
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
});
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), exports.lifecycles, recompose_1.pure);
exports.default = enhance(exports.TranslationsViewPure);
